import { Grid } from "@mui/material";
import Image from "@Components/Image";
import { CMSImageType } from "@Types/Contentful";
import classes from "./CommonSectionTitle.module.scss";

type Props = {
  id?: string;
  title: string;
  icon?: CMSImageType;
};

export const CommonSectionTitle = ({ id, title, icon }: Props) => {
  return (
    <Grid
      className={classes["common-section-title"]}
      container
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      id={id}
    >
      {icon?.url ? (
        <Image
          className={classes["icon"]}
          src={`${icon?.url}?w=60&h=60`}
          width={60}
          height={60}
        />
      ) : (
        <></>
      )}
      <Grid item>
        <h2 className={classes["title"]}>{title}</h2>
      </Grid>
    </Grid>
  );
};

CommonSectionTitle.defaultProps = {
  id: "",
  title: "",
};
